import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Colors } from "../../../constants/styles";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Paper,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahProyek = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [kodeProyek, setKodeProyek] = useState("");
  const [tanggalProyek, setTanggalProyek] = useState(new Date());
  const [namaCustomer, setNamaCustomer] = useState("");
  const [kodeCustomer, setKodeCustomer] = useState("");
  const [namaArsitek, setNamaArsitek] = useState("");
  const [kodeArsitek, setKodeArsitek] = useState("");

  const [customers, setCustomers] = useState([]);
  const [arsiteks, setArsiteks] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTermArsitek, setSearchTermArsitek] = useState("");
  const [openArsitek, setOpenArsitek] = useState(false);
  const [searchTermCustomer, setSearchTermCustomer] = useState("");
  const [openCustomer, setOpenCustomer] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  let [pageArsitek, setPageArsitek] = useState(0);
  const [limitArsitek, setLimitArsitek] = useState(10);
  const [pagesArsitek, setPagesArsitek] = useState(0);
  const [rowsArsitek, setRowsArsitek] = useState(0);
  const [queryArsitek, setQueryArsitek] = useState("");

  const handleChangeArsitek = (e, p) => {
    setPageArsitek(p - 1);
  };

  const searchDataArsitek = (e) => {
    e.preventDefault();
    setPageArsitek(0);
    setSearchTermArsitek(queryArsitek);
  };

  const handleClickOpenArsitek = () => {
    setOpenArsitek(true);
  };

  const handleCloseArsitek = () => {
    setOpenArsitek(false);
  };

  const classes = useStyles();

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermCustomer(query);
  };

  const handleClickOpenCustomer = () => {
    setOpenCustomer(true);
  };

  const handleCloseCustomer = () => {
    setOpenCustomer(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getProyekNextKode();
  }, []);

  useEffect(() => {
    getCustomersData();
  }, [page, searchTermCustomer]);

  useEffect(() => {
    getArsiteksData();
  }, [page, searchTermArsitek]);

  const getProyekNextKode = async () => {
    const response = await postRequest(
      `/proyekNextKode`,
      {},
      navigate,
      dispatch
    );
    setKodeProyek(response.data);
  };

  const getCustomersData = async () => {
    const response = await postRequest(
      `/customersPagination?search_query=${searchTermCustomer}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch
    );
    setCustomers(response.data.customers);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getArsiteksData = async () => {
    const response = await postRequest(
      `/arsiteksPagination?search_query=${searchTermArsitek}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch
    );
    setArsiteks(response.data.arsiteks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const saveProyek = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeArsitek.length !== 0 &&
      kodeCustomer.length !== 0
    ) {
      setLoading(true);
      await postRequest(
        `/saveProyek`,
        {
          kodeProyek,
          tanggalProyek,
          kodeCustomer,
          kodeArsitek,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate("/daftarProyek");
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Proyek</h5>
      <hr />
      <Card>
        <Card.Header>Proyek</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={saveProyek}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Kode :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control value={kodeProyek} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tgl. Proyek <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="9">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalProyek}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setTanggalProyek(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Customer <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control value={namaCustomer} disabled readOnly />
                  </Col>
                  <Col sm="4">
                    <Form.Control
                      required
                      value={kodeCustomer}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenCustomer()}
                      isInvalid={kodeCustomer.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Arsitek <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control value={namaArsitek} disabled readOnly />
                  </Col>
                  <Col sm="4">
                    <Form.Control
                      required
                      value={kodeArsitek}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenArsitek()}
                      isInvalid={kodeArsitek.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/daftarProyek")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openCustomer}
        onClose={handleCloseCustomer}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Customer`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Nama PIC</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customers.map((customer, index) => (
                    <TableRow
                      key={customer._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setKodeCustomer(customer.kodeCustomer);
                        setNamaCustomer(customer.namaCustomer);

                        handleCloseCustomer();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {customer.kodeCustomer}
                      </TableCell>
                      <TableCell>{customer.namaCustomer}</TableCell>
                      <TableCell>{customer.namaPicCustomer}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openArsitek}
        onClose={handleCloseArsitek}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Arsitek`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataArsitek}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryArsitek}
                  setSearchTerm={setQueryArsitek}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>No. Telp</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {arsiteks.map((arsitek, index) => (
                    <TableRow
                      key={arsitek._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setKodeArsitek(arsitek.kodeArsitek);
                        setNamaArsitek(arsitek.namaArsitek);

                        handleCloseArsitek();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {arsitek.kodeArsitek}
                      </TableCell>
                      <TableCell>{arsitek.namaArsitek}</TableCell>
                      <TableCell>{arsitek.teleponArsitek}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesArsitek}
                page={pageArsitek + 1}
                onChange={handleChangeArsitek}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahProyek;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
